export const estadosCiviles = [
  {Id:'D', Nombre: "DIVORCIADO O SEPARADO"},
  {Id:'M', Nombre: "CASADO"},
  {Id:'P', Nombre: "DESCONOCIDO"},
  {Id:'S', Nombre: "SOLTERO"},
  {Id:'U', Nombre: "UNION LIBRE"},
  {Id:'W', Nombre: "VIUDO"},
]
